export function GetEmptyUser() {
  return {
    token: null,
    username: null,
    forename: null,
    surname: null,
    role: null,
    developerId: null,
    developerUserId: null,
    userId: null,
  };
}
